import { Inject, Injectable, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AdviserModel }         from './typings/adviser';
import { ApiService }           from '../api/api.service';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { TableQueryParameters } from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class AdvisersService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService  : ConfirmService,
    private translateService: TranslateService
  ) {}

  create ( adviser : AdviserModel ) : ng.IPromise<AdviserModel> {
    return this.apiService.post('/service_advisers', adviser, 'service_adviser');
  }

  delete ( adviser : AdviserModel ) : ng.IPromise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_SERVICE_ADVISER'))
      .then(() => this.apiService.delete('/service_adviser', adviser.id));
  }

  get ( params : TableQueryParameters ) : ng.IPromise<Array<AdviserModel>> {
    return this.apiService.get('/service_advisers', [
        params.offset    || 0,
        params.pageSize  || 10,
        params.field     || 'display_name',
        params.direction || 'asc'
      ]);
  }

  getById ( id : string ) : ng.IPromise<AdviserModel> {
    return this.apiService.get('/service_adviser', id);
  }

  getCount () : ng.IPromise<number> {
    return this.apiService.get('/service_advisers/count');
  }

  update ( adviser : AdviserModel ) : ng.IPromise<AdviserModel> {
    return this.apiService.patch('/service_adviser', adviser, 'service_adviser');
  }

  validateCode ( code : string, originalCode ?: string ) : ng.IPromise<boolean> {
    return code === originalCode
      ? Promise.resolve(true)
      : this.apiService.post('/service_adviser/verify_adviser_code_uniqueness', {
          adviser_code: code
        });
  }
}
